<template>
  <div class="the-navbar__user-meta flex items-center ml-6" v-if="activeUserName">
    <vs-dropdown
      vs-custom-content
      vs-trigger-click
      class="cursor-pointer"
    >

      <div class="con-img ml-3 flex">
        <div class="leading-tight hidden sm:flex  justify-center items-center mr-3">
          <p class="font-semibold">{{ activeUserName }}</p>
        </div>
        <img v-if="activeUserImage" key="onlineImg" :src="activeUserImage" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer inline-block" />
      </div>

      <vs-dropdown-menu class="dropdown-profile">
        <ul style="min-width: 12rem">
          <li class="flex">
            <router-link :to="{ name: 'user', params: { id: idUser }}" class="cursor-pointer py-3 px-4 block hover:bg-primary hover:text-white w-full" >
              <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
              <span class="ml-2">Perfil</span>
            </router-link>
          </li>

          <vs-divider class="m-1" />
          <li
            class="flex py-3 px-4 cursor-pointer text-primary hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Cerrar sesión</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  computed: {
    activeUserName () {
      return `${this.$store.state.auth.user.name  } ${  this.$store.state.auth.user.surname}`
    },
    activeUserImage () {
        if (this.$store.state.auth.user.avatar) {
            return this.$store.state.auth.user.avatar
        } else {
            return process.env.VUE_APP_AVATAR_DEFAULT;
        }
    },
    idUser () {
      return this.$store.state.auth.user.id
    }
  },
  methods: {
    logout () {
      localStorage.removeItem('user');
      localStorage.removeItem('notifications');
      localStorage.removeItem('currentRestaurant');
      location.reload();

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push({ path: 'login'}).catch(() => {})
    }
  }
}
</script>
